export default __webpack_public_path__ + "static/media/about-us-01.87e865aa.jpg";